export enum StateStatus {
    idle = 'idle',
    loading = 'loading',
    succeeded = 'succeeded',
    failed = 'failed',
    autoLogin = 'autoLogin'
}